module.exports = "<p>\n  components works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/layout/components/components.component.html
// module id = ../../../../../src/app/layout/components/components.component.html
// module chunks = main